import api from './api';

export const fotoService = {
  /**
   * Upload de foto para uma pessoa
   */
  uploadFoto: async (pessoaId, file) => {
    try {
      const formData = new FormData();
      formData.append('foto', file);

      const response = await api.post(`/pessoas/${pessoaId}/foto`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return {
        success: true,
        data: response.data.data,
        message: response.data.message
      };
    } catch (error) {
      console.error('Erro ao fazer upload de foto:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao enviar foto'
      };
    }
  },

  /**
   * Remover foto de uma pessoa
   */
  removeFoto: async (pessoaId) => {
    try {
      const response = await api.delete(`/pessoas/${pessoaId}/foto`);

      return {
        success: true,
        message: response.data.message
      };
    } catch (error) {
      console.error('Erro ao remover foto:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Erro ao remover foto'
      };
    }
  },

  /**
   * Obter URL da foto
   */
  getFotoUrl: (pessoaId, filename) => {
    if (!filename) return null;
    
    // Se já é uma URL completa, retornar
    if (filename.startsWith('http')) {
      return filename;
    }
    
    // Construir URL baseado no ambiente
    const baseUrl = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      ? 'http://localhost:3001/api'
      : 'https://api.ibe.elshadaysystems.com.br/api';
    
    return `${baseUrl}/pessoas/${pessoaId}/foto/${filename}`;
  }
};

export default fotoService;
